import React, { Component } from 'react'
import { withTheme } from 'material-ui/styles'
import _ from 'lodash'
import flat from 'flat'
import { Spinner, Fab } from 'material-ui-elements'
import Paper from 'material-ui-effco/Paper'

import core from '../../core'
import dxTable from '../../grid_table'

import ToolbarOptions from './ToolbarOptions'

const {
  components: { GridTable },
  helpers: {
    extractFormFieldsData,
    setColumnView,
    setColumnOrder,
    validateColumnMinWidths,
    setColumnWidths,
    getRowsWidths,
    updateUrl,
    getUrlObject
  },
  constants: { settings }
} = dxTable

const {
  helpers: { saveToExcel }, // updateUrl, getUrlObject,
  components: { Search } //DownloadButton, Dropzone }
  // styles: { colors }
} = core

class List extends Component {
  state = {}

  async fetchToState() {
    const {
      getData,
      config: { views, columns, defaultSorting, valueTable },
      location
    } = this.props
    const data = await getData() //getEnrichedRegister()
    const availableValues = { ...valueTable, ...data }
    const obj = getUrlObject(location)

    this.setState({
      data,
      margin: false,
      view: 1, //undefined,
      search: { visible: false },
      selection: [],
      hiddenColumnNames: setColumnView(1, views, columns, []),
      columnWidths: setColumnWidths(
        [],
        columns,
        settings,
        availableValues,
        getRowsWidths(
          extractFormFieldsData(columns, data.data),
          columns,
          availableValues
        ),
        true
      ),
      columnMinWidths: setColumnWidths(
        [],
        columns,
        settings,
        availableValues,
        extractFormFieldsData(columns, data.data),
        true,
        true
      ),
      columnOrder: setColumnOrder([], columns),
      initialColumnOrder: setColumnOrder([], columns),
      filters: (obj && obj.filters) || [],
      sorting: (obj && obj.fsorting) || [],
      columns,
      rows: extractFormFieldsData(columns, data.data),
      views,
      lockColumnWidths: false,
      valueTable,
      defaultSorting: defaultSorting || [],
      advancedFilters: [],
      hideFilterRow: true
    })
  }

  async componentWillReceiveProps(nextProps) {
    const { sectionPath, location } = this.props
    const currentSectionPath = nextProps.sectionPath
    const currentLocation = nextProps.location

    if (currentSectionPath !== sectionPath) {
      const data = await nextProps.getData()

      const columns = nextProps.config.columns
      // const rows = extractFormFieldsData(nextProps.config.columns, data.data)
      const availableValues = { ...nextProps.config, ...data.data }
      this.setState({
        ...this.state,
        data: data,
        margin: false,
        columns: nextProps.config.columns,
        views: nextProps.config.views,
        rows: extractFormFieldsData(nextProps.config.columns, data.data),
        initialColumnOrder: setColumnOrder(null, nextProps.config.columns),
        columnOrder: setColumnOrder(null, nextProps.config.columns),
        hiddenColumnNames: setColumnView(
          1,
          nextProps.config.views,
          nextProps.config.columns,
          []
        ),
        columnWidths: setColumnWidths(
          [],
          columns,
          settings,
          availableValues,
          getRowsWidths(
            extractFormFieldsData(columns, data.data),
            columns,
            availableValues
          ),
          true
        ),
        columnMinWidths: setColumnWidths(
          [],
          columns,
          settings,
          availableValues,
          getRowsWidths(
            extractFormFieldsData(columns, data.data),
            columns,
            availableValues
          ),
          true,
          true
        ),
        filters: [],
        lockColumnWidths: false,
        view: 1, //undefined,
        search: { visible: false },
        selection: [],
        defaultSorting: nextProps.config.defaultSorting || [],
        advancedFilters: []
      })
    } else if (location.search !== currentLocation) {
      const obj = getUrlObject(currentLocation)
      this.setState({
        filters: (obj && obj.filters) || [],
        sorting: (obj && obj.sorting) || []
      })
    }
  }

  componentWillMount() {
    const {
      location,
      history: { push },
      sectionPath,
      // constantProps: { PATH },
      config: { defaultSorting }
    } = this.props

    let urlQuery = getUrlObject(location)
    // location.search = urlQuery = updateUrl(location, {
    //   columnViewId: 1,
    //   sorting: defaultSorting
    // })
    location.search = urlQuery = updateUrl(location, {
      columnViewId: 1,
      sorting: defaultSorting,
      filters: urlQuery.filters
    })
    this.fetchToState()
    push(`${sectionPath}?${urlQuery}`)
  }

  updateURL = view => {
    const { location, history: { push }, sectionPath } = this.props
    let urlQuery = getUrlObject(location)

    urlQuery = updateUrl(location, {
      columnViewId: view
    })
    push(`${sectionPath}?${urlQuery}`)
  }

  updateViewURL = view => {
    const {
      location,
      history: { push },
      // constantProps: { PATH },
      sectionPath
    } = this.props

    let urlQuery = getUrlObject(location)

    const columnViewId =
      urlQuery && urlQuery.columnViewId ? urlQuery.columnViewId : undefined
    const newView = columnViewId === undefined ? 1 : 0
    urlQuery = updateUrl(location, {
      columnViewId: newView
    })

    this.setState({
      ...this.state,
      view: columnViewId,
      hiddenColumnNames: setColumnView(
        newView,
        this.state.views,
        this.state.columns,
        this.state.hiddenColumnNames
      ),
      columnOrder: setColumnOrder([], this.state.columns),
      lockColumnWidths: false
    })
    push(`${sectionPath}?${urlQuery}`)
  }

  searchToggle = state => {
    this.setState({
      ...this.state,
      search: {
        ...this.state.search,
        visible: !this.state.search.visible
      },
      margin: !this.state.search.visible
    })
  }

  changeColumnWidths = columnWidths => {
    const validate = validateColumnMinWidths(
      columnWidths,
      this.state.columnMinWidths
    )
    this.setState({
      columnWidths: validate.replace ? validate.columnsWidths : columnWidths,
      lockColumnWidths: true
    })
  }

  changeSelection = selection => this.setState({ ...this.state, selection })

  getSelection = () => {
    const {
      columns,
      rows,
      selection,
      hiddenColumnNames,
      columnOrder
    } = this.state

    let toExport = []
    selection.map(s => {
      const findId = _.find(rows, ['id', s])
      if (findId) {
        const final = []
        _.forOwn(flat.flatten(findId), (value, key) => {
          if (!_.includes(hiddenColumnNames, key)) {
            const column = _.find(columns, ['name', key])
            const columnTitle = _.get(column, 'title')
            if (columnTitle) {
              const valueAdjusted =
                (column &&
                  column.getCellValue &&
                  column.getCellValue(findId)) ||
                value
              final.push({
                title: columnTitle, //[`${columnTitle}`],
                value: valueAdjusted,
                order: _.findIndex(columnOrder, i => i === key)
              })
            }
          }
        })
        if (!_.isEmpty(final)) {
          const finalSorted = _.sortBy(final, ['order']).reduce(
            (prev, curr, index) => {
              return { ...prev, [`${curr.title}`]: curr.value }
            },
            {}
          )
          toExport.push(finalSorted)
        }
      }
      return s
    })

    saveToExcel(toExport, 'test')
  }

  changeFilters = (filters, addToUrl = true) => {
    const {
      location,
      history: { push },
      sectionPath
      // constantProps: { PATH }
    } = this.props
    const urlQuery = updateUrl(location, { filters: filters })

    this.setState({ ...this.state, filters })
    if (addToUrl) push(`${sectionPath}?${urlQuery}`)
  }

  hiddenColumnNamesChange = hiddenColumnNames => {
    this.setState({ hiddenColumnNames })
  }

  changeColumnOrder = order => {
    const { initialColumnOrder } = this.props
    this.setState({ columnOrder: order || initialColumnOrder })
  }

  changeMargin = margin => {
    this.setState({
      margin: margin !== undefined ? margin : !this.state.margin
    })
  }

  render() {
    const {
      data,
      search,
      filters,
      hideFilterRow,
      selection,
      hiddenColumnNames,
      columns,
      rows,
      views,
      // valueTable,
      columnOrder,
      initialColumnOrder,
      defaultSorting,
      margin,
      columnWidths,
      columnMinWidths,
      lockColumnWidths
    } = this.state
    const {
      history: { push },
      sectionPath,
      constantProps: { NAME, LABEL, DATE_FORMAT },
      config: { valueTable, subFormDetails },
      location
      // theme: { palette }
      //snackbar
    } = this.props
    if (!data) return <Spinner />

    const listRecords = data.data

    const availableValues = { ...valueTable, ...data } //reasons, centres }

    const multiple = true

    return (
      <div>
        <Fab
          onClick={() =>
            push(
              `${sectionPath}new${
                location.search !== '' ? '/' + location.search : ''
              }`
            )
          }
          color="default"
          style={{ bottom: 110 }}
        />
        <Paper
          style={{
            marginRight: margin ? 310 : 0
          }}
        >
          <GridTable
            // lang="pl"
            // disabled={true}
            title={
              sectionPath === '/register/'
                ? `Young People's ${LABEL}`.toUpperCase()
                : `${subFormDetails.label}`.toUpperCase()
            }
            name={NAME}
            path={sectionPath} //{PATH}
            dateFormat={DATE_FORMAT}
            topComponent={
              <ToolbarOptions
                updateViewURL={this.updateViewURL}
                searchToggle={this.searchToggle}
                getSelection={this.getSelection.bind(this)}
                changeFilters={this.changeFilters}
                isFilters={!_.isEmpty(filters)}
                isSelection={!_.isEmpty(selection)}
                filters={filters}
                columns={columns}
              />
            }
            changeSelection={this.changeSelection}
            selection={selection}
            filters={filters}
            defaultFilters={filters}
            multiple={multiple}
            changeFilters={this.changeFilters}
            hideFilterRow={hideFilterRow || search.visible}
            hiddenColumnNamesChange={this.hiddenColumnNamesChange}
            hiddenColumnNames={hiddenColumnNames}
            columnOrder={columnOrder}
            initialColumnOrder={initialColumnOrder}
            changeColumnOrder={this.changeColumnOrder}
            changeColumnWidths={this.changeColumnWidths}
            unLockColumnWidths={this.unLockColumnWidths}
            // editingPlugin
            sortingPlugin
            filteringPlugin
            selectionPlugin
            selectionCheckboxAlways
            verticalScrollingPlugin
            pagingPlugin
            columnResizingPlugin
            columnReorderingPlugin
            columnVisibilityPlugin
            // groupingPlugin
            updateViewURL={this.updateViewURL}
            changeMargin={this.changeMargin}
            input={{
              data: listRecords,
              columns: columns,
              view: this.state.view,
              views: views,
              rows: rows, //extractFormFieldsData(columns, listRecords),
              sorting: defaultSorting,
              grouping: [],
              availableValues: availableValues,
              pageSizes: [10, 20, 50, 0],
              //initialHeight: 1000
              margin,
              columnWidths,
              lockColumnWidths,
              columnMinWidths
            }}
            {...this.props}
            // {...this.state}
          />
        </Paper>

        <Search
          search={search}
          searchToggle={this.searchToggle}
          columns={columns.filter(
            f =>
              f.filterField &&
              !_.includes(hiddenColumnNames, f.name) &&
              !f.hidden
          )}
          filters={filters}
          dateFormat={DATE_FORMAT}
          changeFilters={this.changeFilters}
          availableValues={availableValues}
          {...this.props}
          // {...this.state}
        />
      </div>
    )
  }
}

export default withTheme()(List)



// WEBPACK FOOTER //
// ./src/common/components/List.js